import z from 'zod';
import {
  CalculateMaximumMortgageFormSchema,
  ENERGY_LABELS,
} from '~/pages/Tools/CalculateMaximumMortgage/Calculate/schema';

type CalculateMaximumMortgageFormValues = z.infer<
  typeof CalculateMaximumMortgageFormSchema
>;

export { ENERGY_LABELS };
export type EnergyLabel = (typeof ENERGY_LABELS)[number];

export const EnergyLabelLabels: Record<EnergyLabel, string> = {
  Unknown: 'Onbekend',
  'A++++': 'A++++',
  'A+++': 'A+++',
  'A++': 'A++',
  'A+': 'A+',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
};

export type MortgageType = 'Annuity' | 'Linear' | 'InterestOnly';

export const MortgageTypeLabels: Record<MortgageType, string> = {
  Annuity: 'Annuïtair',
  Linear: 'Lineair',
  InterestOnly: 'Aflossingsvrij',
};

export type MortgagePeriod = 5 | 10 | 15 | 20 | 30;

export const MortgagePeriodMap: Record<
  MortgagePeriod,
  CalculateMaximumMortgageFormValues['interestPeriod']
> = {
  5: '5',
  10: '10',
  15: '15',
  20: '20',
  30: '30',
};

export type LoadedMortgageCalculationEntry = {
  type: MortgageType;
  periods: MortgagePeriod[];
};

export type MortgageCalculationMetadata = {
  loadedEntries: LoadedMortgageCalculationEntry[];
};

export type MortgageCalculationResult = {
  results: ProviderMortgageResult[];
  metadata: MortgageCalculationMetadata;
};

export type ProviderMortgageResult = {
  slug: string;
  name: string;
  logoUrl?: string;
  sortOrder?: number;
  campaignCode?: string;
  mortgages: MortgageResult[];
};

export type MortgageResult = {
  type: MortgageType;
  amount: number;
  netMonthlyCosts: number;
  grossMonthlyCosts: number;
  fixedRatePeriodInMonths: number;
  rate: number;
};
